<div class="container-fluid header">
    <div class="row topBanner justify-content-between">
        <div class="col-2">
            <img class="headerLogo" src="assets/images/PPL-logo-3.png">
        </div>

        <div class="col-10" style='text-align: right;'>


            <div class="header-wrapper">
                <div class="header-wrapper-first">
                    @if (redirectUser?.navbarUser?.first_name != undefined && redirectUser?.navbarUser?.first_name !=
                    '') {
                    <p class="headerContent Montserrat_bold">
                        {{redirectUser?.navbarUser?.first_name}}
                        {{redirectUser?.navbarUser?.surname}}
                        ({{redirectUser?.navbarUser?.canvasser_code}})
                    </p>
                    <p class="headerContent Montserrat_bold">
                        {{redirectUser?.navbarUser?.store_name}}
                        ({{redirectUser?.navbarUser?.store_no}})
                    </p>

                    <p class="headerContent Montserrat_bold">
                        {{ currentDate | date:'yyyy-MM-dd HH:mm' }}
                    </p>
                    }
                </div>

                <div class="header-wrapper-second">
                    @if (isUniversalCanvasser) {
                    <button class="form-control headerButtons headerButtons-wide" [disabled]="!canChangeRetailer"
                        (click)="changeRetailer()">
                        Change Retailer
                    </button>
                    }

                    <button class="form-control headerButtons" (click)="logout()">
                        Logout
                    </button>
                </div>
            </div>

        </div>

    </div>
    <div class="row bottomBanner justify-content-center">
        <div class="col-12 bannerCol align-self-center">
            <div class="bannerText">
                APP SELECTION
            </div>
        </div>
    </div>

</div>